module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delete_category_confirmation":"Are you sure you want to delete this category? This category will be deleted permanently."},"id":{"delete_category_confirmation":"Anda yakin ingin menghapus kategori ini? Kategori ini akan dihapus secara permanen."}}')
  delete Component.options._Ctor
}
